//
// import {EventSourcePolyfill} from "event-source-polyfill";
// import {getToken} from "@/utils/auth";
//
// const defaultOptions = {
//     retry: 5,
//     interval: 3 * 1000,
// };
//
// class SSEClient {
//     constructor(url, options = defaultOptions) {
//         this.url = url;
//         this.es = null;
//         this.options = options;
//         this.retry = options.retry;
//         this.timer = null;
//         this.isCompleted = false; // 请求完成的标志
//     }
//
//     // 打开连接时触发
//     _onOpen() {
//         if (this.isCompleted) return; // 如果已完成，不处理 open 事件
//         console.log("Server Sent Event connection established");
//     }
//
//     // 消息处理函数
//     _onMessage(handler) {
//         return (event) => {
//             if (this.isCompleted) return; // 如果已完成，不处理消息
//
//             this.retry = this.options.retry; // 重置重试次数
//
//             try {
//                 // 判断是否是结束标识 [DONE]
//                 if (event.data.includes("[DONE]")) {
//                     console.log("Received completion signal, stopping reconnection.");
//                     this.isCompleted = true;
//                     this.unsunscribe(); // 断开连接，停止重连
//                     return;
//                 }
//
//                 // 提取并存储 id
//                 const idMatch = event.data.match(/id:(\d+)/);
//                 if (idMatch) {
//                     const id = idMatch[1];
//                     console.log("Storing ID to localStorage:", id);
//                     if (localStorage.getItem("messageId") === '0') {
//                         localStorage.setItem("messageId", id); // 存储到 localStorage
//                     }
//                 }
//
//                 // 处理正常 JSON 数据
//                 if (event.data.indexOf("{") !== -1) {
//                     const payload = JSON.parse(event.data);
//                     console.log("Receiving data...", payload);
//
//                     // 调用自定义的处理方法
//                     if (typeof handler === "function") {
//                         handler(payload);
//                     }
//                 }
//             } catch (error) {
//                 console.error("Failed to parse payload from server", error);
//             }
//         };
//     }
//
//     // 错误处理和重连机制
//     _onError(type, handler) {
//         return (event) => {
//             if (this.isCompleted) return; // 如果已完成，不处理错误事件
//             // 输出错误详细信息
//             throw new Error("asdfasdfasdfas")
//             if (this.es) {
//                 this._removeAllEvent(type, handler); // 移除所有事件监听
//                 this.unsunscribe(); // 断开当前连接
//             }
//
//             // 如果还需要重连
//             if (this.retry > 0) {
//                 // 如果是 EventSource 被关闭了，则不重连
//                 if (event && event.target && event.target.readyState === EventSource.CLOSED) {
//                     console.log("EventSource closed, not retrying.");
//                     return;
//                 }
//
//                 this.timer = setTimeout(() => {
//                     this.subscribe(type, handler); // 重连
//                 }, this.options.interval);
//             } else {
//                 this.retry--; // 减少重试次数
//             }
//         };
//     }
//
//     // 移除所有事件监听
//     _removeAllEvent(type, handler) {
//         if (this.es) {
//             this.es.removeEventListener("open", this._onOpen);
//             this.es.removeEventListener(type, this._onMessage(handler));
//             this.es.removeEventListener("error", this._onError(type, handler));
//         }
//     }
//
//     // 订阅消息
//     subscribe(type, handler) {
//         if (this.isCompleted) return; // 如果已完成，不再订阅
//
//         this.es = new EventSourcePolyfill(this.url, {
//             heartbeatTimeout: 60 * 60 * 1000,
//             headers: {
//                 "X-Access-Token": getToken(),
//             },
//         });
//
//         this.es.addEventListener("open", this._onOpen.bind(this)); // 连接成功时触发
//         this.es.addEventListener(type, this._onMessage(handler)); // 接收到消息时触发
//         this.es.addEventListener("error", this._onError(type, handler)); // 出错时触发
//
//         // 连接关闭时，确保更新 isCompleted 标志
//         this.es.addEventListener("close", () => {
//             this.isCompleted = true; // 设置标志为已完成
//             this.unsunscribe(); // 断开连接
//         });
//     }
//
//     // 取消订阅
//     unsunscribe() {
//         if (this.es) {
//             this.es.close(); // 关闭连接
//             this.es = null;
//         }
//         if (this.timer) {
//             clearTimeout(this.timer); // 清除重连定时器
//         }
//     }
// }
//
// export default SSEClient;

//
// import {EventSourcePolyfill} from "event-source-polyfill";
// import {getToken} from "@/utils/auth";
//
// const defaultOptions = {
//     retry: 5,
//     interval: 3 * 1000,
// };
//
// class SSEClient {
//     constructor(url, options = defaultOptions) {
//         this.url = url;
//         this.es = null;
//         this.options = options;
//         this.retry = options.retry;
//         this.timer = null;
//         this.isCompleted = false;
//         this.isPaused = false;
//     }
//
//     _onOpen() {
//         if (this.isCompleted || this.isPaused) return;
//         console.log("Server Sent Event connection established");
//     }
//
//     _onMessage(handler) {
//         return (event) => {
//             if (this.isCompleted || this.isPaused) return;
//             this.retry = this.options.retry;
//
//             try {
//                 if (event.data.includes("[DONE]")) {
//                     console.log("Received completion signal, stopping connection.");
//                     this.isCompleted = true;
//                     this.stop();
//                     return;
//                 }
//
//                 const idMatch = event.data.match(/id:(\d+)/);
//                 // const idMatch = event.data.match(/id:([^\s]+)/); // 匹配 id: 后的所有非空白字符
//                 if (idMatch) {
//                     const id = idMatch[1];
//                     console.log("Storing ID to localStorage:", id);
//                     if (localStorage.getItem("messageId") === '0') {
//                         localStorage.setItem("messageId", id);
//                     }
//                 }
//
//                 if (event.data.indexOf("{") !== -1) {
//                     const payload = JSON.parse(event.data);
//                     console.log("Receiving data...", payload);
//                     if (typeof handler === "function") {
//                         handler(payload);
//                     }
//                 }
//             } catch (error) {
//                 console.error("Failed to parse payload from server", error);
//             }
//         };
//     }
//
//     _onError(type, handler) {
//         return (event) => {
//             if (this.isCompleted || this.isPaused) return;
//
//             if (this.es) {
//                 this._removeAllEvent(type, handler);
//                 this.stop();
//             }
//
//             if (this.retry > 0) {
//                 if (event?.target?.readyState === EventSource.CLOSED) {
//                     console.log("EventSource closed, not retrying.");
//                     return;
//                 }
//                 this.timer = setTimeout(() => {
//                     this.start(type, handler);
//                 }, this.options.interval);
//                 this.retry--;
//             }
//         };
//     }
//
//     _removeAllEvent(type, handler) {
//         if (this.es) {
//             this.es.removeEventListener("open", this._onOpen);
//             this.es.removeEventListener(type, this._onMessage(handler));
//             this.es.removeEventListener("error", this._onError(type, handler));
//         }
//     }
//
//     start(type, handler) {
//         if (this.isCompleted) return;
//         this.isPaused = false;
//
//         this.es = new EventSourcePolyfill(this.url, {
//             heartbeatTimeout: 60 * 60 * 1000,
//             headers: {
//                 "X-Access-Token": getToken(),
//             },
//         });
//
//         this.es.addEventListener("open", this._onOpen.bind(this));
//         this.es.addEventListener(type, this._onMessage(handler));
//         this.es.addEventListener("error", this._onError(type, handler));
//         this.es.addEventListener("close", () => {
//             this.isCompleted = true;
//             this.stop();
//         });
//     }
//
//     stop() {
//         if (this.es) {
//             this.es.close();
//             this.es = null;
//         }
//         if (this.timer) {
//             clearTimeout(this.timer);
//         }
//         this.retry = this.options.retry;
//     }
//
//     pause() {
//         this.isPaused = true;
//         this.stop();
//     }
//
//     resume(type, handler) {
//         if (this.isPaused) {
//             this.isPaused = false;
//             this.start(type, handler);
//         }
//     }
// }
//
// export default SSEClient;


// import {fetchEventSource} from "@microsoft/fetch-event-source";
// import {getToken} from "@/utils/auth";
//
// class SSEClient {
//     constructor(url) {
//         this.url = url;
//         this.controller = null;
//         this.isCompleted = false;
//         this.isRunning = false;
//         this.body = null;
//     }
//
//     start(body, handler) {
//         // 防止重复 start
//         if (this.isRunning) return;
//
//         this.isRunning = true;
//         this.isCompleted = false;
//         this.body = body;
//         this.controller = new AbortController();
//
//         fetchEventSource(this.url, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//                 "X-Access-Token": getToken(),
//             },
//             body: JSON.stringify(body),
//             signal: this.controller.signal,
//
//             // 🔥 禁用 fetch-event-source 内置 retry
//             openWhenHidden: true,
//
//             onopen: (res) => {
//                 if (!res.ok) {
//                     throw new Error("SSE open failed");
//                 }
//                 console.log("SSE connected");
//             },
//
//             onmessage: (event) => {
//                 if (this.isCompleted) return;
//
//                 if (event.data === "[DONE]") {
//                     this.isCompleted = true;
//                     this.close();
//                     return;
//                 }
//
//                 try {
//                     handler?.(JSON.parse(event.data));
//                 } catch (e) {
//                     console.warn("invalid sse payload", event.data);
//                 }
//             },
//
//             onerror: (err) => {
//                 // ❗不要 retry POST
//                 console.error("SSE error", err);
//                 this.close();
//                 throw err; // 直接终止
//             },
//         });
//     }
//
//     close() {
//         this.controller?.abort();
//         this.controller = null;
//         this.isRunning = false;
//     }
// }
//
// export default SSEClient;


import {fetchEventSource} from "@microsoft/fetch-event-source";
import {getToken} from "@/utils/auth";
import {Storage} from "@/utils/storage";

class SSEClient {
    constructor(url) {
        this.url = url;

        this.controller = null;
        this.body = null;

        this.isRunning = false;
        this.isPaused = false;
        this.isCompleted = false;
        //1共用 2邮件助手
        this.type = 1;
    }

    start(body, type, handler) {
        // ❗防止重复 POST
        if (this.isRunning || this.isCompleted) return;

        this.body = body;
        this.type = type
        this.isRunning = true;
        this.isPaused = false;

        this.controller = new AbortController();

        fetchEventSource(this.url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Access-Token": getToken(),
            },
            body: JSON.stringify(body),
            signal: this.controller.signal,
            openWhenHidden: true,

            // 🚫 禁止自动 retry
            onopen: (res) => {
                if (!res.ok) {
                    throw new Error("SSE open failed");
                }
                console.log("SSE connected");
            },

            onmessage: (event) => {
                if (this.isPaused || this.isCompleted) return;
                if (event.data === "[DONE]") {
                    this.isCompleted = true;
                    this._cleanup();
                    return;
                }

                const idMatch = event.data.match(/id:(\d+)/);
                // const idMatch = event.data.match(/id:([^\s]+)/); // 匹配 id: 后的所有非空白字符
                if (idMatch) {
                    const id = idMatch[1];
                    console.log("Storing ID to localStorage:", id);
                    const TargetString = this.type === 1 ? "messageId" : "messageIdMail"
                    if (Storage.get(TargetString) === '0') {
                        Storage.set(TargetString, id);
                    }
                }

                // if (event.data.indexOf("{") !== -1) {
                //     const payload = JSON.parse(event.data);
                //     console.log("Receiving data...", payload);
                //     if (typeof handler === "function") {
                //         handler(payload);
                //     }
                // }

                try {
                    handler?.(JSON.parse(event.data));
                } catch (e) {
                    console.warn("Invalid SSE data:", event.data);
                }
            },

            onerror: (err) => {
                // ❗POST 模式下，error 直接停
                console.error("SSE error:", err);
                this._cleanup();
                throw err;
            },
        });
    }

    pause() {
        if (!this.isRunning || this.isCompleted) return;

        this.isPaused = true;
        this.controller?.abort(); // 中断连接
        this.controller = null;
        this.isRunning = false;
    }

    resume(handler) {
        if (!this.isPaused || this.isCompleted) return;

        // ⚠ resume = 重新 POST（必须后端支持同一任务）
        this.start(this.body, handler);
    }

    stop() {
        if (this.isCompleted) return;

        this.isCompleted = true;
        this._cleanup();
    }

    _cleanup() {
        this.controller?.abort();
        this.controller = null;
        this.isRunning = false;
        this.isPaused = false;
    }
}

export default SSEClient;